export const asyncSleep = async (miliseconds: number) => {
  await new Promise(r => setTimeout(r, miliseconds));
};
